<template>
    <tr>
        <td>{{ boleto.nome }}</td>
        <td>{{ boleto.imovel.endereco.enderecoCompleto }}</td>
        <td>
            <input v-if="editarVencimento" :min="minDate" type="date" lang="pt-BR" v-model="vencimento">
            <span v-else>
                {{ boleto.dataVencimento }}
            </span>
            <a v-if="editarVencimento && !loading"  @click="atualizarVencimento" target="_blank" class="default-button">Atualizar</a>
            <a v-if="loading && editarVencimento"  class="default-button">Atualizando...</a>
        </td>
        <td>R${{ boleto.valorAtualizado }}</td>
        <td>{{ boleto.competencia }}</td>
        <td>
            <a v-if="boleto.atualizarVencimento=='N' && url_segunda_via!=''" :href="url_segunda_via" target="_blank" class="default-button">baixar</a>
            <a v-else-if="boleto.atualizarVencimento=='N' && url_segunda_via==''" @click="solicitar2Via" target="_blank" class="default-button">
                <span v-if="loading">Solicitando...</span>
                <span v-else>

                    Solicitar 2ª Via
                </span>
            </a>

        </td>
        <td v-if="!editarVencimento">
            <a v-if="boleto.atualizarVencimento=='S'" @click="editVencimento" target="_blank" class="default-button">Alterar vencimento</a>
        </td>
        <td v-else>
            <a v-if="boleto.atualizarVencimento=='S'" @click="editVencimento" target="_blank" class="default-button">Cancelar</a>            
        </td>
        <td v-if="banner_popup!=''">
            <a href="#popup_parcele_clic" class="fancybox-vue default-button">PARCELE O SEU BOLETO</a>            
        </td>
        <td v-if="popup_simulacao==1">
            <a class="default-button" @click="showPopupSimulacao">SIMULE O PARCELAMENTO <br /> DO SEU BOLETO</a>            
            <div v-show="false">
                <div ref="popup_simulacao" class="popup-simulacao" >
                    <CreditCard :valor="valor_boleto" ></CreditCard>
                </div>
            </div>
        </td>
    </tr>
</template>
<script>

import axios from 'axios';
import md5 from 'md5';
import $ from 'jquery';
import { app_endpoint } from '../config';
import moment from 'moment';

import 'date-input-polyfill';

import CreditCard from 'vilarica-popup-segunda-via/src/CreditCard.vue';

export default {
    props: ['boleto', 'banner_popup', 'popup_simulacao'],
    components: {
        CreditCard
    },
    data() {
        var d = moment().format('YYYY-MM-DD');

        return {
            loading: false,
            editarVencimento: false,
            vencimento: d,
            minDate: d,
            url_segunda_via: ''
        };
    },
    computed: {
        hash() {
            const { codigoCliente, cpfCnpj } = this.boleto;
            return md5(`${codigoCliente}${cpfCnpj}`);
        },
        url_atualizar() {
            //return this.getUrl('download-boleto');
            return this.getUrl('alteraDataVencimentoBoletoInquilino');
        },
        url_download() {
            return this.getUrl('segunda-via');
        },
        valor_boleto() {
            return +this.boleto.valorAtualizado.replace('.','').replace(',','.');
        }
    },
    methods: {
        getUrl(path = 'download-boleto') {
            const hash = this.hash;
            let { 
                codigoCliente:codCliente, 
                sistema,
                imovel: {
                    codigo:codUnidade
                },
                codigo: codDoc,
                dataVencimento: vencimento

            } = this.boleto;


            let data = vencimento.split(/\//igm).reverse().join('-');            
            vencimento = data;

            if (this.boleto.atualizarVencimento == 'S') {
                data = this.vencimento;
            }

            let tipo = 'Condomínio';
            if ('A' == sistema) {
                tipo = 'Aluguel';
            }

            const { cpfCnpj } = this.boleto;

            const params = $.param({
                hash,
                cpfCnpj,
                codCliente,
                codUnidade,
                codDoc,
                tipo,
                data,
                vencimento
            });

            const url = `${app_endpoint}/${path}?${params}`;
            return url;
        },
        editVencimento() {
            this.editarVencimento = !this.editarVencimento;
        },
        async solicitar2Via() {
            this.loading = true;
            await axios.get(this.url_download)
                .then(({ data }) => {
                    if (!data.success) {
                        throw new Error(data.msg);
                    }
                    this.url_segunda_via = `${app_endpoint}/download?arquivo=${data.arquivo}`;
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response.data) {
                        err = new Error(err.response.data.error);
                    }
                    alert(err.message);
                });
            this.loading = false;
        },
        async atualizarVencimento() {
            this.loading = true;
            await axios.get(this.url_atualizar)
                .then(({ data }) => {
                    if (!data.success) {
                        throw new Error(data.msg);
                    }
                    this.$emit("atualizarVencimento");
                })
                .catch(err => {
                    if (err.response && err.response.data) {
                        err = new Error(err.response.data.error);
                    }
                    alert(err.message);
                    console.error(err);
                });
            this.loading = false;
        },
        showPopupSimulacao() {
            console.log(this.boleto,'ok');
 
            window.$.fancybox(this.$refs.popup_simulacao, {
                title: "Simule o parcelamento do seu boleto",
                maxWidth: 800
            })
        }
    },
    mounted() {
        window.$('.fancybox-vue').fancybox({
            helpers : {
                title : {
                    type : 'inside'
                },
                overlay : {
                    locked : false
                }
            },
            live: true,
            afterShow: function() {
                $(':text').setMask();
            }
        });
    },
    updated() {
        window.$('.fancybox-vue').fancybox({
            helpers : {
                title : {
                    type : 'inside'
                },
                overlay : {
                    locked : false
                }
            },
            live: true,
            afterShow: function() {
                $(':text').setMask();
            }
        });
    }
}
</script>
<style lang="less" scoped>
    .popup-simulacao {
        padding: 1em;
    }
</style>